import script from "./toggle-archive-template-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./toggle-archive-template-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__